import { render, staticRenderFns } from "./CommunityShare.vue?vue&type=template&id=95ae0c12&scoped=true&"
import script from "./CommunityShare.vue?vue&type=script&lang=js&"
export * from "./CommunityShare.vue?vue&type=script&lang=js&"
import style0 from "./CommunityShare.vue?vue&type=style&index=0&id=95ae0c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ae0c12",
  null
  
)

export default component.exports